import { render } from "./HomeLogo.vue?vue&type=template&id=4956f277&scoped=true"
import script from "./HomeLogo.vue?vue&type=script&lang=js"
export * from "./HomeLogo.vue?vue&type=script&lang=js"

import "./HomeLogo.vue?vue&type=style&index=0&id=4956f277&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4956f277"]])

export default __exports__